import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/app-shared/src/public-api';
import { ArticulosEcommerce, ArticulosGeneral, EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'mmax-search-results',
  templateUrl: './mmax-search-results.component.html',
  styleUrls: ['./mmax-search-results.component.scss']
})
export class MmaxSearchResultsComponent implements OnInit {
  @Input('mode') modo: string = 'normal';
  @Input() myData: string = 'none';
  @Input() login: string = 'none';

  menues = [
    {
      nombre: 'Mis Datos',
      url: '/misdatos',
      urlmobile: '/app-mobile/app/account',
      icourl: '../../assets/icons/credit-card-outline-white.svg'
    }
  ];

  resultadosDeLaBusqueda: ArticulosGeneral[] = [];
  swicher = false;
  isLogued: boolean;
  beneficiosTrue = false;
  constructor(private serv: MarianomGeneral, private genServ : EcommerceGenericoService, private route: ActivatedRoute, private modal: ModalService) {
    this.isLogued = this.serv.isloged();
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.modo = data['mode'] || this.modo;
    });

    this.genServ.returnBeneficios().subscribe(data => {
      this.beneficiosTrue = data === 'S';
    })

    this.actualizarEstadoLogin();

    this.genServ.getLastSearchProvider().subscribe(data => {
      const fechaActual = new Date().toISOString().split('T')[0];

      this.resultadosDeLaBusqueda = data.filter(element =>
        element.isdeoferta
          ? element.deOferta.fechahasta > fechaActual
          : true
      );
    });

    this.genServ.getUsuarioProvider().subscribe(data => {
      if (data !== undefined) {
        this.isLogued = this.serv.isloged();
        this.actualizarEstadoLogin();
      }
    });

    this.genServ.getAvisoArticulosSucursalCargados().subscribe(() => {
      this.genServ.iniciarbusqueda('');
    });
  }

  private actualizarEstadoLogin() {
    if (this.isLogued) {
      this.myData = 'flex';
      this.login = 'none';
    } else {
      this.myData = 'none';
      this.login = 'block';
    }
  }

  get toggleSideBar(){
    return this.serv.getOcultarSideBarBusqueda()
  }

  get categorias() {
    return this.genServ.getCategoriasWeb();
  }

  get menus(): MenuMmaxInterface[] {
    const beneficios: MenuMmaxInterface = {
      nombre: 'Beneficios',
      ruta: 'beneficios',
      activo: false
    };

    if (this.beneficiosTrue) {
      const index = this.serv.rutas.findIndex(m => m.nombre === beneficios.nombre);
      if (window.innerWidth < 1000 && index === -1) {
        this.serv.rutas.push(beneficios);
      } else if (window.innerWidth >= 1000 && index !== -1) {
        this.serv.rutas.splice(index, 1);
      }
    }
    return this.serv.rutas;
  }

 /*  openLogin() {
    this.serv.gotoURL('', this.route);
    setTimeout(() => this.modal.open('login-modal-1'), 10);
  }

  cerrarSesion() {
    this.modal.open('modal-salir');
  }

  gotoURL(url: string) {
    this.menus.forEach(m => (m.activo = false));
    this.serv.gotoURL(url, this.route);
  }

  menuclick(menus: MenuMmaxInterface) {
    if (!this.isLogued && (menus.ruta === 'historial' || menus.ruta === 'sucursales')) {
      this.serv.abrirModalLogin();
    } else {
      this.serv.gotoURL(`/${menus.ruta}`, this.route);
      this.serv.activatethis(menus);
    }
  }

  reiniciarFiltroCategoria(categoriaSeleccionada : any){
    if (!categoriaSeleccionada.desplegado) {
      this.genServ.iniciarbusqueda('');
    }
  } */
}